const common = {
  entType: {
    circulate: '0',
    production: '1',
    retail: '2'
  },
  entTypeMap: {
    '0': '流通企业',
    '1': '生产企业',
    '2': '零售企业'
  },
  getWarningTypeText(code, type) {
    const warningTypeMap = {
      '2': '过效期销售',
      '4': '温度异常',
      '5': '湿度异常',
      '6': '原辅料检验不合格',
      '7': '原辅料检验报告缺失',
      '8': '成品检验不合格',
      '9': '成品检验报告缺失',
      '10': '原辅料过效期',
      '11': '过效期库存',
      '12': '营业执照过期',
      '13': type === '1' ? '生产许可证过期' : '经营许可证过期',
      '14': '温湿度异常',
      '15': '非指定供应商',
      '17': '洁净度超限',
      '18': '进销不平衡',
      '19': '经营范围超限',
      '20': '召回品销售',
      '21': '营业执照证照临近过期',
      '22': type === '1' ? '生产许可证临期' : '经营许可证临期'
    };
    return warningTypeMap[code];
  },
  warnDealStatus: {
    '0': '处置中',
    '1': '已处置',
    '2': '企业已反馈'
  }
};

function freezeCommon(obj) {
  for (const key in obj) {
    if (common[key] instanceof Object) {
      Object.freeze(common[key]);
      freezeCommon(common[key]);
    }
  }
}

freezeCommon(common);

export default common;
